import React from 'react';
import copyIcon from 'images/copy-link-icon.svg';
import { EmbedLinkContainer } from '../styles.js';

const EmbedLink = ({ show, openCopyEmbedLinkDialog, classNames }) => {
  return (
    <>
      {show ? (
        <EmbedLinkContainer
          className={classNames}
          onClick={() => {
            openCopyEmbedLinkDialog && openCopyEmbedLinkDialog(true);
          }}
        >
          <img src={copyIcon} /> <p>Add tool to your website</p>
        </EmbedLinkContainer>
      ) : null}
    </>
  );
};

export default EmbedLink;
